import _extends from "@babel/runtime/helpers/extends";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@material-ui/core';
import CodeIcon from '@material-ui/icons/Code';
import React, { useState } from 'react';
import { useLocalization } from "../../hooks/index.js";
import { HtmlEditor } from "../html-editor.js";
export const HTMLEditorControl = ({
  editor,
  buttonProps
}) => {
  const [open, setOpen] = useState(false);
  const [html, setHtml] = useState(editor.getHTML());
  const localization = useLocalization();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const saveHTMLContent = () => {
    editor.chain().focus().setContent(html, true).run();
    setOpen(false);
  };
  const handleClose = () => {
    if (editor.getHTML() === html) {
      setOpen(false);
      return;
    }
    const confirmResult = window.confirm(localization.HTMLEditorControl.confirm);
    if (!confirmResult) {
      return;
    }
    saveHTMLContent();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: `${localization.menubar.EditHtml}`
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    onClick: () => handleClickOpen(),
    color: editor.isActive('code') ? 'primary' : 'default'
  }, buttonProps), /*#__PURE__*/React.createElement(CodeIcon, {
    style: {
      marginTop: '-7px'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      fontSize: '12px',
      top: '13px',
      fontWeight: 'bold'
    }
  }, "html"))), /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "html-editor-control-title",
    fullWidth: true,
    maxWidth: "lg",
    onExited: () => {}
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "html-editor-control-title"
  }, localization.HTMLEditorControl.title), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(HtmlEditor, {
    initialState: editor.getHTML(),
    fieldOnChange: setHtml
  })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      setOpen(false);
    }
  }, localization.common.cancel), /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      saveHTMLContent();
    },
    color: "primary"
  }, localization.linkControl.submit))));
};
//# sourceMappingURL=html-editor-control.js.map